export const getCoordinatesByAddress = async (address) => {
  const location = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address.street1}%20${address.street2}%20${address.postcode}%20${address.city}&key=AIzaSyACCs5y681MayfxRymmNO7wrWjDCGFvvQA`
  ).then((res) => res.json());

  console.log('Location fetched:', location);
  const result = location.results?.[0];
  if (!result) return {};

  const latitude = result.geometry.location.lat + '';
  const longitude = result.geometry.location.lng + '';

  return { latitude, longitude };
};
